<h3 mat-dialog-title class="title-layout">{{teamName}} - {{versionName}} - {{pitchFormType}} 
    &nbsp;&nbsp; 
    <span [ngStyle]="{'color': serviceColor, 'font-size': '150%', 'font-weight': 'bold'}" [innerHTML] = "serviceAttribute"></span>
</h3>
<span class="button-row">
  <button class="create-multiple-button" *ngIf="(this.existing_pitches===0)" color="primary" [disabled] = "isBusy" mat-raised-button (click)="togglePitchCreateMode()">{{pitchCreateMessage}}</button>
</span>

  <div mat-dialog-content style="max-height: 750px; overflow: auto;">
    <form [formGroup]="pitchFormGroup">
      <small class="multiple-msg" *ngIf="this.createMultiplePitches">You are creating {{this.num_pitches}} new {{this.teamTypePlural}}.<br><br></small>  
      <small class="error" *ngIf="this.subassemblyexists">
          You CANNOT EDIT the selected {{teamType}}'s Type and {{teamType}} fields because it has subassemblies; Subassembly IDs: {{listofexistingsubassemblyID}} <br><br>
      </small>
      
      <mat-form-field class="card-dialog" *ngIf="!this.createMultiplePitches">
        <mat-label>Type</mat-label>
        <mat-select id="type" matInput cdkTextareaAutosize formControlName="form_pitchType" required>
          <mat-option *ngFor="let type of typeOptions" [disabled]="(type !== 'pitch' && subassemblyexists && pitchType === 'pitch') || this.createMultiplePitches" [value]="type">
            {{type}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      
      <mat-form-field class="card-dialog" *ngIf="this.createMultiplePitches">
        <mat-label *ngIf="this.createMultiplePitches">Type</mat-label>
        <mat-select id="multiCreateType" matInput cdkTextareaAutosize formControlName="form_pitchType" required>
          <mat-option value={{this.teamType.toLowerCase()}} disabled="true">
            {{this.teamType.toLowerCase()}}
          </mat-option>
        </mat-select>
      </mat-form-field>

    
      <mat-form-field class="card-dialog" *ngIf="this.pitchType != 'subassembly'">
        <mat-label *ngIf="this.pitchType != 'subassembly'">{{ teamType }} ID</mat-label>
        <input id="pitch" type="text" matInput cdkTextareaAutosize formControlName="form_pitchID"
          [readonly]="(pitchType==='pitch' && subassemblyexists)? true: false" required>
      </mat-form-field>
      <div *ngIf="pitchFormGroup.get('form_pitchID')?.invalid && 
              pitchFormGroup.get('form_pitchID')?.errors && 
              (pitchFormGroup.get('form_pitchID')?.dirty || pitchFormGroup.get('form_pitchID')?.touched)">
        <small class="error" *ngIf="pitchFormGroup.get('form_pitchID')?.hasError('required')"> {{teamType}} is Required </small>
        <small class="error"
          *ngIf="!pitchFormGroup.get('form_pitchID')?.hasError('required') && pitchFormGroup.get('form_pitchID')?.hasError('lengthThree')">
          {{teamType}} must be at least 3 characters </small>
        <small class="error"
          *ngIf="!pitchFormGroup.get('form_pitchID')?.hasError('lengthThree') && pitchFormGroup.get('form_pitchID')?.hasError('rightThreeNumber')">
          {{teamType}} must end with a value in the range 000 to 999 </small>
      </div>
  
      
      <mat-form-field class="card-dialog" *ngIf="this.pitchType == 'subassembly'">
        <mat-label *ngIf="this.pitchType == 'subassembly'">{{ teamType }} ID</mat-label>
        <mat-select id="pitch" matInput cdkTextareaAutosize formControlName="form_pitchID" required>
          <mat-option *ngFor="let pitch of availablePitchIDs" [value]="pitch">
            {{pitch}}
          </mat-option>
        </mat-select>
      </mat-form-field>
  
      
      <mat-form-field class="card-dialog" *ngIf="this.pitchType == 'subassembly'">
        <mat-label *ngIf="this.pitchType == 'subassembly'">Subassembly</mat-label>
        <mat-select id="subassembly" matInput cdkTextareaAutosize formControlName="form_subassemblyID">
          <mat-option *ngFor="let option of subassemblyIDOptions" [value]="option">
            {{option}}
          </mat-option>
        </mat-select>
      </mat-form-field>
  
      
      <mat-form-field class="card-dialog" *ngIf="!this.createMultiplePitches">
        <mat-label *ngIf="!this.createMultiplePitches">Status</mat-label>
        <mat-select id="status" matInput cdkTextareaAutosize formControlName="form_status">
          <mat-option *ngFor="let pStatus of pitchStatuses" [value]="pStatus">
            {{pStatus}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      
      <mat-form-field class="card-dialog" *ngIf="this.coveredByAnotherTeam">
        <mat-label *ngIf="this.coveredByAnotherTeam">Cover Team</mat-label>
        <mat-select id="cover-team" matInput cdkTextareaAutosize formControlName="form_coverTeam">
          <mat-option *ngFor="let team of availableTeams" [value]="team.team_id">
            {{ team.subline + ' Team: ' + team.team_name }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      
      <mat-form-field class="card-dialog" *ngIf="this.createMultiplePitches">
        <mat-label *ngIf="this.createMultiplePitches">Status</mat-label>
        <mat-select id="multiCreateStatus" matInput cdkTextareaAutosize formControlName="form_status">
          <mat-option value = "active" disabled="true">
            active
          </mat-option>
        </mat-select>
      </mat-form-field>
  
      
      <mat-form-field class="card-dialog" *ngIf="this.pitchType == 'waterspider' || this.pitchType == 'kitter' || this.pitchType == 'repacker'">
        <mat-label>{{ teamTypePlural }}</mat-label>
        <mat-select id="pitch ties" matInput cdkTextareaAutosize formControlName="form_service_ties" multiple>
          <mat-option *ngFor="let pitch of availablePitches" [value]="pitch.pitch_config_id" disabled="true">
            {{pitch.pitch_id}}
          </mat-option>
        </mat-select>
      </mat-form-field>
  
      
      <mat-form-field class="card-dialog" *ngIf="!this.createMultiplePitches">
        <mat-label>{{ teamType }} Name</mat-label>
        <input id="pitchname" type="text" matInput cdkTextareaAutosize formControlName="form_pitchName">
      </mat-form-field>
  
      
      <mat-form-field class="card-dialog">
        <mat-label>{{ teamTimeType }} Time</mat-label>
        <input id="taktTime" type="number" [readonly]="createMultiplePitches" matInput cdkTextareaAutosize
          formControlName="form_taktTime" required>
      </mat-form-field>
      <div *ngIf="pitchFormGroup.get('form_taktTime')?.invalid && 
          pitchFormGroup.get('form_taktTime')?.errors && 
          (pitchFormGroup.get('form_taktTime')?.dirty || pitchFormGroup.get('form_taktTime')?.touched)">
        <small class="error" *ngIf="pitchFormGroup.get('form_taktTime')?.hasError('required')">
          {{teamTimeType}} time is required.
        </small>
      </div>
      
      
      <mat-form-field class="card-dialog">
        <mat-label>Flags</mat-label>
        <mat-select id="type" matInput cdkTextareaAutosize formControlName="form_flags" multiple >
          <mat-option *ngFor="let flag of availableFlagIDs" [value]="flag">
            {{flag}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <br>
      <button *ngIf = "errorFlag === 'no error' || errorFlag === 'Duplicated Model Variant'" 
        class="add-variant-button" mat-button [disabled]="disableVariantSelection"
        (click)="defineTeamVariant()"> 
        <mat-icon>add</mat-icon>
          <span> Define Pitch Variant </span>
      </button>
      <button
        *ngIf="errorFlag != 'no error' && materials == 'no'" 
        class="resolve-variant-button" mat-button color="warn" 
        (click)="resolveVariantError()">
        
        <mat-icon>error_outline</mat-icon>
        {{ errorFlag === 'Duplicated Model Variant'
          ? 'View Duplicated Model Variant'
          : ('Resolve ' + errorFlag) }}
      </button>
        <small class="variant-error" *ngIf="teamVariants.length <= 0">
            The pitch must have at least one variant.
        </small>
      
      <div class="variant-container">
          <button *ngFor="let variant of teamVariants" 
            [ngClass]="variantInError(variant)? 'variant-error-button': 'variant-button'">
                  <button 
                    [ngClass]="variantInError(variant)? 'clear-error-button': 'clear-button-name'" 
                    [matTooltip]="variant.model_variants.length + ' model variants.'"
                    (click)="errorFlag === 'no error' && editVariant(variant)">{{variant.variant_name}}</button>
                  <button 
                    [ngClass]="variantInError(variant)? 'clear-error-button': 'clear-button'" 
                    [matTooltip]="'Remove Variant'"
                    (click)="removeVariant(variant)" *ngIf="!disableVariantSelection">
                      <mat-icon class="small-delete-icon">clear</mat-icon>
                  </button>
          </button> 
      </div>
                            
      <mat-label *ngIf="this.createMultiplePitches">Even/Odd</mat-label>
      <mat-form-field class = "card-dialog" *ngIf="this.createMultiplePitches">
        <mat-select id = "even_odd" matInput cdkTextareaAutosize formControlName="form_evenOdd">
            <mat-option *ngFor="let option of evenOddOptions" [value]="option">   
                {{option}}
            </mat-option>
        </mat-select>
      </mat-form-field>

    </form>
  </div>
  <div *ngIf="isBusy">
  
    <mat-spinner></mat-spinner>
  
  </div>
  
  <div mat-dialog-actions>
    <div *ngIf="pitchFormGroup.status === 'VALID' && !unique" [style]="{'color': 'red', 'font-weight': 'bold', 'padding-bottom': '20px'}">
      A {{teamType}} can only be created or updated if a {{teamType}} with the same ID does not exist for the team.
    </div>
    <button *ngIf="pitchFormType == 'Create New Pitch' || pitchFormType == 'Create New Route'" [disabled]="pitchFormGroup.status === 'INVALID' || isBusy" mat-raised-button
      color="primary" (click)="createPitch()">Create</button>
    <button *ngIf="pitchFormType == 'Edit Pitch' || pitchFormType == 'Edit Route'" [disabled]="pitchFormGroup.status === 'INVALID' || isBusy" mat-raised-button color="primary" (click)="updatePitch()">Update</button>
    <button *ngIf="canDelete" [disabled] = "isBusy" mat-raised-button color="warn" (click)="deletePitch()">Delete {{teamType}}</button>
    <span class="spacer"></span>
    <button mat-raised-button color="primary" (click)="onNoClick()">Close</button>
  </div>